/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface AnforderungDetailControllerGetAnforderungDokumenteV1$Params {
  anforderungsversionID: number;
}

export function anforderungDetailControllerGetAnforderungDokumenteV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerGetAnforderungDokumenteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerGetAnforderungDokumenteV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

anforderungDetailControllerGetAnforderungDokumenteV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/dokumente';
